function Hello(){
    alert("Hello World");
}

export default {
    Hello
}